import React, { useEffect, useState } from "react";
import { IoMdReorder } from "react-icons/io";
import { AiOutlineUser } from "react-icons/ai";
import { HiMenu } from "react-icons/hi";
import { config } from "../../../config";
import axios from "axios";
import Logout from "../../Logout";

 // Get user ID from localStorage

const LMSNavbar = () => {

  const imageUrl = config.imageUrl;
  const apiUrl = config.apiUrl;
  const id = localStorage.getItem("id");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isProfileFormOpen, setIsProfileFormOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [logo, setLogo] = useState(null);
  const [formData, setFormData] = useState({
    name: "", 
    email: "",
    phone: "",
    password: "", // Added password field
  });

  const navItems = [
    { label: "Your Courses", href: "/student" },
    { label: "Blogs", href: "/blog" }
  ];



  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/users/${id}`);
        setUser(response.data.user); // Set user data
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/heroes`);
        setLogo(response.data.heroes[0].logo); // Set user data
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Handler for form submission
  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      setErrorMessage("");
      const response = await axios.put(`${apiUrl}/usersupdate/${id}`, formData);

      if (response.data.message === "Password not match") {
        setErrorMessage("Password not match"); // Display error message
      } else {
        setIsProfileFormOpen(false);
        setUser(formData); // Update the user state
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  // Handler for input changes in the profile form
  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handler to show the profile form and update formData from user state
  const handleProfileClick = () => {
    setFormData({
      name: user?.name || "",
      email: user?.email || "",
      phone: user?.phone || "",
      password: "", // Reset password field when opening form
    });
    setIsProfileFormOpen(true);
    setIsProfileMenuOpen(false);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <nav className="bg-gray-700 shadow relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <a href="/" className="flex items-center">
              <img src={`${imageUrl}/${logo}`} alt="" className="h-12 w-44 object-contain"/>
            </a>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-100 hover:text-gray-300"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          {/* Profile Button & Dropdown Container */}
          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            <div className="relative">
              <button
                onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
                className="relative rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">Open user menu</span>
                <AiOutlineUser className="h-6 w-6" />
              </button>
              {isProfileMenuOpen && (
                <div className="absolute right-0 top-full mt-2 w-48 bg-white shadow-lg rounded-md py-1 z-50">
                  <button
                    onClick={handleProfileClick}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
                  >
                    Profile
                  </button>
                  <div
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <Logout />
                  </div>
                </div>
              )}
              {/* Profile Form - Desktop */}
              {isProfileFormOpen && (
                <div className="absolute right-0 top-full mt-2 w-48 bg-white shadow-lg rounded-md py-4 px-4 z-50">
                  <h2 className="text-lg font-semibold text-gray-900 mb-2">
                    Update Profile
                  </h2>
                  <form className="space-y-2" onSubmit={handleProfileSubmit}>
                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleProfileChange}
                        className="mt-1 p-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Email
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleProfileChange}
                        readOnly // Make email uneditable
                        className="mt-1 p-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Phone Number
                      </label>
                      <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleProfileChange}
                        className="mt-1 p-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Password
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleProfileChange}
                        className="mt-1 p-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                    </div>
                    <div className="flex justify-end">
                      <button
                        type="button"
                        onClick={() => setIsProfileFormOpen(false)}
                        className="mr-2 px-2 py-1 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-2 py-1 bg-indigo-600 text-white text-sm font-medium rounded-md shadow hover:bg-indigo-500"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>

          <div className="flex items-center sm:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="-mr-2 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            >
              <span className="sr-only">Open main menu</span>
              {isMobileMenuOpen ? (
                <HiMenu className="block h-6 w-6" aria-hidden="true" />
              ) : (
                <IoMdReorder className="block h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div className="sm:hidden">
          <div className="pt-2 pb-3 space-y-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="block pl-3 pr-4 py-2 text-base font-medium text-gray-700 hover:bg-gray-50"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </div>
          <div className="pt-4 pb-3 border-t border-gray-200">
            <button
              onClick={handleProfileClick}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
            >
              Profile
            </button>
            <Logout />
          </div>
        </div>
      )}

      {/* Mobile Profile Form */}
      {isProfileFormOpen && (
        <div className="sm:hidden absolute left-0 top-16 mt-2 w-full bg-white shadow-lg rounded-md py-4 px-4 z-50">
          <h2 className="text-lg font-semibold text-gray-900 mb-2">
            Update Profile
          </h2>
          <form onSubmit={handleProfileSubmit}>
            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700">
                Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleProfileChange}
                className="mt-1 p-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleProfileChange}
                className="mt-1 p-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700">
                Phone Number
              </label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleProfileChange}
                className="mt-1 p-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleProfileChange}
                className="mt-1 p-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
            <div className="flex justify-end">
              <button
                type="button"
                onClick={() => setIsProfileFormOpen(false)}
                className="mr-2 px-2 py-1 text-sm text-gray-700 hover:bg-gray-100 rounded-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-2 py-1 bg-indigo-600 text-white text-sm font-medium rounded-md shadow hover:bg-indigo-500"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      )}
    </nav>
  );
};

export default LMSNavbar;
